import { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import { Loading } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useEmailCampaignGate } from '../hooks/useEmailCampaignGate';

type EmailCampaignGateGuardProps = {
  children: ReactNode;
};

export const EmailCampaignGateGuard: FC<EmailCampaignGateGuardProps> = ({ children }) => {
  const { gate, isLoading } = useEmailCampaignGate();

  if (isLoading) {
    return <Loading />;
  }

  if (gate !== 'ready') {
    return <Redirect to={RouteConstants.emailCampaigns} />;
  }

  return <>{children}</>;
};
